export default __webpack_public_path__ + "static/media/BAKA_ikona_web-02.83e8035d.svg";